import { render, staticRenderFns } from "./ColourPickerOption.vue?vue&type=template&id=08c97a14&scoped=true&"
import script from "./ColourPickerOption.vue?vue&type=script&lang=js&"
export * from "./ColourPickerOption.vue?vue&type=script&lang=js&"
import style0 from "./ColourPickerOption.vue?vue&type=style&index=0&id=08c97a14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c97a14",
  null
  
)

export default component.exports